import React from 'react';
import { ThumbsUp, MessageCircle, Heart } from 'lucide-react';
const comments = [{
  name: 'Carlos T.',
  initials: 'CT',
  color: 'bg-blue-600',
  time: '2h',
  text: 'Llevo 2 semanas y anoche me dormí en 15 minutos. QUINCE. Antes era hora y media mínimo 😭',
  likes: 47,
  replies: 8,
  reaction: 'love'
}, {
  name: 'Andrea Fernández',
  initials: 'AF',
  color: 'bg-indigo-600',
  time: '5h',
  text: 'El guión de desenganche suena raro al principio pero FUNCIONA. Mi mente se calla.',
  likes: 92,
  replies: 14,
  reaction: 'love'
}, {
  name: 'Luis G.',
  initials: 'LG',
  color: 'bg-slate-600',
  time: '1d',
  text: 'Amigo el que lo está dudando: son $6.39. Yo gastaba más en melatonina al mes.',
  likes: 134,
  replies: 22,
  reaction: 'like'
}, {
  name: 'Sofía Martínez',
  initials: 'SM',
  color: 'bg-emerald-600',
  time: '1d',
  text: 'Lo que más me ayudó fue entender que pelear con los pensamientos es lo que te mantiene despierto.',
  likes: 78,
  replies: 11,
  reaction: 'love'
}, {
  name: 'Miguel Morales',
  initials: 'MM',
  color: 'bg-amber-600',
  time: '2d',
  text: 'Compré escéptico. A la tercera noche mi esposa me preguntó qué me pasaba porque me dormí antes que ella 😂',
  likes: 63,
  replies: 9,
  reaction: 'like'
}, {
  name: 'Camila Reyes',
  initials: 'CR',
  color: 'bg-rose-600',
  time: '2d',
  text: 'La descarga de 6 minutos es oro. Vacías la cabeza en papel y tu mente se calma.',
  likes: 201,
  replies: 31,
  reaction: 'love'
}, {
  name: 'Alejandra V.',
  initials: 'AV',
  color: 'bg-violet-600',
  time: '3d',
  text: 'Mamá soltera, dos trabajos, ansiedad de noche. Este protocolo me devolvió mis noches 💪',
  likes: 88,
  replies: 15,
  reaction: 'love'
}, {
  name: 'Fernando López',
  initials: 'FL',
  color: 'bg-teal-600',
  time: '4d',
  text: 'Pensé que era otro PDF de tips. Pero no. Es un SISTEMA. No te pide motivación, te pide 6 minutos.',
  likes: 156,
  replies: 27,
  reaction: 'like'
}, {
  name: 'Renata Díaz',
  initials: 'RD',
  color: 'bg-cyan-600',
  time: '4d',
  text: 'Semana 3: duermo 6-7 horas seguidas. Antes me despertaba a las 3am y no volvía a dormir 🤯',
  likes: 243,
  replies: 35,
  reaction: 'love'
}, {
  name: 'Isabela Ruiz',
  initials: 'IR',
  color: 'bg-orange-600',
  time: '5d',
  text: 'Mi hijo de 15 años también lo usa. Dice que el ritual mínimo le ayuda con los exámenes 🥹',
  likes: 112,
  replies: 18,
  reaction: 'love'
}, {
  name: 'Natalia Herrera',
  initials: 'NH',
  color: 'bg-lime-700',
  time: '5d',
  text: 'No es magia. Es dejar de pelear. Suena simple pero nadie te lo explica así.',
  likes: 95,
  replies: 12,
  reaction: 'like'
}, {
  name: 'Claudio Peña',
  initials: 'CP',
  color: 'bg-fuchsia-600',
  time: '6d',
  text: 'El mini-protocolo para despertares de madrugada me salvó. Antes entraba en pánico.',
  likes: 67,
  replies: 7,
  reaction: 'love'
}, {
  name: 'Mónica Salazar',
  initials: 'MS',
  color: 'bg-sky-600',
  time: '1sem',
  text: 'Dejé de sentir miedo a la cama. DEJÉ DE SENTIR MIEDO. Eso solo vale los $6.39 y más.',
  likes: 178,
  replies: 24,
  reaction: 'love'
}, {
  name: 'Adrián Castro',
  initials: 'AC',
  color: 'bg-red-500',
  time: '1sem',
  text: 'Mis amigos me preguntan cómo duermo tan bien ahora. Les digo: dejé de intentar dormir 😎',
  likes: 54,
  replies: 6,
  reaction: 'like'
}, {
  name: 'Jimena Ortiz',
  initials: 'JO',
  color: 'bg-yellow-600',
  time: '1sem',
  text: 'Primera semana completa. Dormí 5/7 noches sin dar vueltas. Nunca en mi vida.',
  likes: 189,
  replies: 29,
  reaction: 'love'
}, {
  name: 'Karla Mendoza',
  initials: 'KM',
  color: 'bg-green-600',
  time: '1sem',
  text: 'El plan de emergencias me salvó el jueves. Noche horrible → guión + ritual → dormido en 20 min.',
  likes: 73,
  replies: 10,
  reaction: 'like'
}, {
  name: 'Daniel Vargas',
  initials: 'DV',
  color: 'bg-purple-500',
  time: '2sem',
  text: 'Compré para mí y terminé mandándoselo a mi hermano. Ahora los dos dormimos tranquilos 🤍',
  likes: 121,
  replies: 16,
  reaction: 'love'
}, {
  name: 'Teresa Romero',
  initials: 'TR',
  color: 'bg-slate-500',
  time: '2sem',
  text: 'No es un libro de sueño. Es paz mental empaquetada en un PDF. Suena exagerado pero es real.',
  likes: 145,
  replies: 20,
  reaction: 'love'
}, {
  name: 'Lorena Ríos',
  initials: 'LR',
  color: 'bg-pink-500',
  time: '2sem',
  text: 'Antes: celular hasta las 2am porque «total no me duermo». Ahora: protocolo a las 10:30, dormido a las 11.',
  likes: 167,
  replies: 23,
  reaction: 'love'
}, {
  name: 'Verónica Gil',
  initials: 'VG',
  color: 'bg-blue-500',
  time: '3sem',
  text: 'A todos los que dicen «mi mente es demasiado intensa»: la mía también. Por eso funciona. Porque es simple.',
  likes: 210,
  replies: 33,
  reaction: 'like'
}];
export default function FacebookCommentsSection() {
  return <div className="py-10 px-4 sm:px-6 lg:px-8 bg-brand-cream-dark" data-id="element-40">
      <div className="max-w-xl mx-auto" data-id="element-41">
        <h3 className="font-heading text-2xl md:text-3xl text-white text-center mb-1 tracking-wide uppercase" data-id="element-42">
          Lo que dicen en redes
        </h3>
        <p className="text-sm text-slate-400 text-center mb-5" data-id="element-43">
          Comentarios reales de nuestra comunidad
        </p>

        <div className="max-h-[420px] overflow-y-auto space-y-2 pr-1 rounded-lg" style={{
        scrollbarWidth: 'thin'
      }} data-id="element-44">
          {comments.map((c, i) => <div key={i} className="bg-brand-navy rounded-lg border border-white/5 px-3 py-2.5" data-id="element-45">
              <div className="flex gap-2.5" data-id="element-46">
                <div className={`w-7 h-7 ${c.color} rounded-full flex items-center justify-center flex-shrink-0`} data-id="element-47">
                  <span className="text-white text-[10px] font-bold" data-id="element-48">
                    {c.initials}
                  </span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-49">
                  <div className="flex items-center gap-1.5 mb-0.5" data-id="element-50">
                    <span className="font-semibold text-slate-200 text-xs" data-id="element-51">
                      {c.name}
                    </span>
                    <span className="text-[10px] text-slate-500" data-id="element-52">
                      · {c.time}
                    </span>
                  </div>
                  <p className="text-slate-300 text-[13px] leading-relaxed mb-1.5" data-id="element-53">
                    {c.text}
                  </p>
                  <div className="flex items-center justify-between" data-id="element-54">
                    <div className="flex items-center gap-1" data-id="element-55">
                      <div className="flex -space-x-1" data-id="element-56">
                        <div className="w-4 h-4 bg-[#1877F2] rounded-full flex items-center justify-center border border-brand-navy" data-id="element-57">
                          <ThumbsUp size={8} className="text-white fill-white" data-id="element-58" />
                        </div>
                        {c.reaction === 'love' && <div className="w-4 h-4 bg-red-500 rounded-full flex items-center justify-center border border-brand-navy" data-id="element-59">
                            <Heart size={8} className="text-white fill-white" data-id="element-60" />
                          </div>}
                      </div>
                      <span className="text-[10px] text-slate-500" data-id="element-61">
                        {c.likes}
                      </span>
                    </div>
                    <div className="flex items-center gap-3 text-[10px] text-slate-500" data-id="element-62">
                      <span className="flex items-center gap-0.5" data-id="element-63">
                        <ThumbsUp size={9} data-id="element-64" /> Me gusta
                      </span>
                      <span className="flex items-center gap-0.5" data-id="element-65">
                        <MessageCircle size={9} data-id="element-66" /> {c.replies}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}